import type {FC} from 'react';

import type {Props} from './types';

import * as S from './styles';

export const ListItem: FC<Props> = ({
  onMoreIconClick,
  repeat,
  time,
  title,
  variant,
}) => {
  return (
    <S.Container>
      <S.IconContainer variant={variant}>
        {variant === 'task' ? <S.TaskIcon /> : null}
        {variant === 'conference' ? <S.ConferenceIcon /> : null}
      </S.IconContainer>
      <S.Content>
        <S.LabelsContainer>
          <S.Label>{time}</S.Label>
          {repeat ? <S.Label>{repeat}</S.Label> : null}
        </S.LabelsContainer>
        <S.Title>{title}</S.Title>
      </S.Content>
      <S.MoreIconClickable onClick={onMoreIconClick}>
        <S.MoreIcon />
      </S.MoreIconClickable>
    </S.Container>
  );
};
